import React, { Component } from "react";
// import {curators} from "./RoleList"
import {myMSALObj} from './Configurations';


class NavBar extends Component {
    constructor(props){
        super(props);
        this.state = {
            guid:"",
            curator:false
    
        }
    }

    componentDidMount(){
        //console.log('aaaaa')
        if(myMSALObj.getAccount() !== null){
            this.setState({
                guid:myMSALObj.getAccount().accountIdentifier
            }) 
            fetch("https://data-catalog-token-server-dev-v2.azurewebsites.net/api/roleLookUp?guid="+myMSALObj.getAccount().accountIdentifier).then(res=>res.json()).then(data=>{
                // console.log(data)//ONLY USED FOR TOKEN TESTING. COMMENT THIS LINE OUT BEFORE PUSHING ONTO PROD SERVER.
            this.setState({curator:data['curator']},()=>{
                console.log('the new code')
                if(data['curator'] === true || data['owner'] === true){
                    sessionStorage.setItem("role","curator")
                }else{
                    sessionStorage.setItem("role","user")
                }
                
            })
        })
        }

        
        // if (curators.includes(sessionStorage.getItem("email"))){
        //     sessionStorage.setItem("role","curator")
        // }else{
        //     sessionStorage.setItem("role","user")
        // }
        // console.log(this.props)
    }


    render(){
        //console.log(this.state)
        return (
            <nav  className="navbar navbar-dark bg-dark py-0">
                <a className="navbar-brand" href="/">
                    <img className="img-fluid" src = "https://pngimg.com/uploads/un/un_PNG21.png"></img>
                    {/* <img className="img-fluid" src = "https://pngimg.com/uploads/un/un_PNG21.png"></img> */}
                    <strong className="text-white pl-2">UN DATA EXCHANGE</strong>
                </a>
                <div className="form-inline personal-info-dropdown">
                    <a  className="nav-link dropdown-toggle py-0 nav-dropdown" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="py-0 pr-2 text-white nav-email" >{sessionStorage.getItem('email')}</span><br/>
                        <span className="py-0 pr-2 text-white nav-un " >UNITED NATIONS</span>
                    </a>
                    <i className="fa fa-angle-down" aria-hidden="true" role="button" data-toggle="dropdown"></i>
                    <div  className="dropdown-menu dropdown-menu-right shadow-sm border-0 mr-2 mt-0 nav-dropdown-show" aria-labelledby="navbarDropdown">
                        <div className="dropdown-item">
                        <div className="container-fluid px-0 mb-0">
                            <h6 className="float-left small user-select-none">United Nations</h6>
                            <a onClick={this.props.handleLogOut} href="#"><h6 className="float-right small" >Sign Out</h6></a>
                        </div>
                        <hr className="mt-0" />
                        </div>
                        <div className="float-left pl-4 ml-2 pb-3">
                            <i className="far fa-user-circle fa-4x" aria-hidden="true"></i>
                        </div>
                        <div className="float-right pr-4 mr-4">
                            <span style={{backgroundColor:"#344A5A"}} className="ml-1 badge badge-info">{this.state.curator===true?" CURATOR":" GENERAL USER"}</span>
                            {this.state.curator===true?<span className="ml-5 pl-3 new-entry-icon" onClick={this.props.handleCreate} title="Create a new record"><i className="far fa-edit"></i></span>:null}
                            <h5 className="ml-1 mb-0 user-select-none">{sessionStorage.getItem('user')}</h5>
                            <h6 className="ml-1 small user-select-none" >{sessionStorage.getItem('email')}</h6>
                        </div>
                    </div>
                </div>
            </nav>
        )
    }
};


export default NavBar;